import { EventJournalQueries } from '@entities/eventJournal/model/queries';

export const useGetInitialQueryStateInfo = ({ params }: { params: Record<string, string> }) => {
    // небольшой костыль. === 2 потому что не учитываем query-параметры dash_tab и sort
    const isOnlyTwoParams = Object.keys(params).length === 2;
    const hasSortProp = Object.keys(params).includes(EventJournalQueries.sort);

    return {
        isOnlyTwoParams,
        hasSortProp,
    };
};
